import Vue from 'vue'
import Router from 'vue-router'
import BaseView from '@/components/BaseView'
import Upload from '@/components/Upload';
import Watch from '@/components/Watch';
import Home from '@/components/Home'
import Shows from '@/components/Shows'
import Seasons from '@/components/Seasons';
import Episodes from '@/components/Episodes';

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'BaseView',
        component: BaseView,
        children: [{
                path: '/watch/:id',
                component: Watch
            },
            {
                path: '/upload',
                component: Upload
            },
            {
                path: '/',
                component: Home
            },
            {
                path: '/shows',
                component: Shows
            },
            {
                path: '/seasons/:name',
                component: Seasons
            },
            {
                path: '/episodes/:showName/:seasonName',
                component: Episodes
            }
        ]
    }],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js